import React from 'react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/15122544193"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-[9999] flex items-center gap-3 group"
    >
      {/* Label */}
      <span className="bg-zinc-950/80 backdrop-blur-md border border-zinc-800 text-white px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Let's Connect
      </span>

      {/* Button */}
      {/* Humne 'overflow-hidden' hata diya hai aur 'relative' rakha hai */}
      <div className="btn-animated-gold w-14 h-14 rounded-full flex items-center justify-center shadow-2xl relative cursor-pointer">
        
        {/* Icon: Ise alag se absolute position de di taake ye kisi cheez se na dabbe */}
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="WhatsApp" 
          className="w-8 h-8 absolute z-[100]" 
          style={{ 
            display: 'block', 
            filter: 'brightness(0) invert(1)' // Ye icon ko white kar dega taake Gold par saaf dikhe
          }} 
        />
      </div>
    </a>
  );
};

export default WhatsAppButton;